<template>
  <div class="title-slot-container">
    <medium-title v-if="typeTitle === 'default'">
      {{ title }}
    </medium-title>
    <div class="big-title-container" v-else-if="typeTitle === 'big'">
      {{ title }}
    </div>
    <div class="mini-title-container" v-else-if="typeTitle === 'mini'">
      {{ title }}
    </div>
    <slot/>
  </div>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";

export default {
  name: "TitleSlot",
  components: {MediumTitle},
  props: {
    typeTitle: {
      type: String,
      default: 'default'
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .title-slot-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 12px;

    .medium-title-container {
      color: var(--color-dark-green)
    }
    .big-title-container {
      font-size: 18px;
      color: var(--color-dark-green)
    }
    .mini-title-container {
      font-size: 14px;
      color: var(--color-light-purple-white)
    }
  }
</style>